import React from 'react'
import '../style/whoami.css'
import img2 from '../images/galleryImage/bannn-2.jpg'
import img3 from '../images/galleryImage/bannn-3.jpg'
import img4 from '../images/galleryImage/Bannnn-1.jpg'

const Carousel = () => {
    return (
        <>
            <div id="carouselExampleSlidesOnly" className="carousel slide" data-bs-ride="carousel">
                <div className="carousel-inner">
                    <div className="carousel-item active" data-bs-interval="3000">
                        <img id='imgCaro' src={img2} className="d-block w-100 h-100" alt="bannerImage" />
                    </div>
                    <div className="carousel-item" data-bs-interval="3000">
                        <img id='imgCaro' src={img3} className="d-block w-100" alt="bannerImage" />
                    </div>
                    <div className="carousel-item" data-bs-interval="3000">
                        <img id='imgCaro' src={img4} className="d-block w-100" alt="bannerImage" />
                        <div className="carousel-caption d-none d-md-block">
                            <a href='/UmangRataniLandingPage'>
                                <button className="btn btn-primary">Contact Us</button>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default Carousel
